module.exports = __webpack_public_path__ + "img/hat_10.adeb0fed.png";